import { CalendarApi } from '@fullcalendar/react';
import { CalendarDateService } from '@uplift/services';


export const scrollCalendarToCurrentTime = (calendarApi: CalendarApi, timezone: string) => {
  const now = CalendarDateService.date().tz(timezone);
  const maxSubstractHours = now.hour();
  let formatted = '00:00:00';

  if (maxSubstractHours >= 2) {
    const twoHoursBeforeNow = now.subtract(2, 'hours');

    formatted = twoHoursBeforeNow.format('HH:mm:ss');
  }
  calendarApi.scrollToTime(formatted);
};


export const getScroller = () => {
  const scroller = document.querySelector('.fc-scroller.fc-scroller-liquid-absolute');
  const scrollerBody = scroller?.querySelector('.fc-timegrid-body');

  return [ scroller, scrollerBody ] as const;
};
